module.exports = __webpack_public_path__ + "annualreview2017/static/pdfs/future-energy.0cab493.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/future-energy.pdf
// module id = 639
// module chunks = 0